import moment from 'moment';

export const roundDate = date => {
  const roundedDate = moment({
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate()
  });

  return roundedDate.format();
};

